import React from 'react';
import { bool, node, func, string } from 'prop-types';

import Row from '../Container/Row';
import EmptyStateWrapper from '../EmptyState/EmptyStateWrapper';
import ActivityIndicator from '../ActivityIndicator';

const getFetchingWrapper = (
  blankSpace,
  blankHeightLoader,
  empty,
  theme,
  move,
  enableErrorRevamp
) => {
  return (
    <Row justifyContent="center" position="relative">
      {blankSpace ? (
        <Row height={blankHeightLoader}>
          <ActivityIndicator position="absolute" top="64px" empty={empty} />
        </Row>
      ) : move ? (
        <ActivityIndicator position="absolute" top="64px" empty={empty} />
      ) : (
        <ActivityIndicator position="absolute" top="64px" empty={empty} />
      )}
    </Row>
  );
};

const getEmptyStateWrapper = (
  empty,
  type,
  emptyAction,
  children,
  theme,
  move,
  enableErrorRevamp
) => {
  console.log('getEmptyStateWrapperisMoveEnabled', move);
  return (
    <EmptyStateWrapper
      isEmpty={empty}
      type={type}
      action={emptyAction}
      theme={theme}
      move={move}
      enableErrorRevamp={enableErrorRevamp}
    >
      {children}
    </EmptyStateWrapper>
  );
};

const getFailedWrapper = (
  type,
  failedAction,
  theme,
  move,
  enableErrorRevamp
) => {
  return getEmptyStateWrapper(
    true,
    type,
    failedAction,
    false,
    theme,
    move,
    enableErrorRevamp
  );
};

const LoadingWrapper = ({
  fetching,
  failed,
  empty,
  children,
  failedAction = Function,
  emptyAction = Function,
  type = '',
  blankSpace,
  blankHeight,
  isFilterError,
  filterErrorType,
  clearFilter,
  theme,
  move,
  enableErrorRevamp,
}) => {
  const blankHeightLoader = blankHeight || '100vh';

  if (failed)
    return getFailedWrapper(type, failedAction, theme, move, enableErrorRevamp);
  if (fetching)
    return getFetchingWrapper(
      blankSpace,
      blankHeightLoader,
      empty,
      theme,
      move
    );
  if (isFilterError)
    return getEmptyStateWrapper(
      empty,
      filterErrorType,
      clearFilter,
      (children = null),
      theme,
      move,
      enableErrorRevamp
    );
  return getEmptyStateWrapper(
    empty,
    type,
    emptyAction,
    children,
    theme,
    move,
    enableErrorRevamp
  );
};

LoadingWrapper.propTypes = {
  fetching: bool,
  failed: bool,
  empty: bool,
  children: node,
  failedAction: func,
  emptyAction: func,
  type: string,
  blankSpace: bool,
  blankHeight: string,
  isFilterError: bool,
  filterErrorType: string,
  clearFilter: func,
  theme: string,
  move: bool,
  enableErrorRevamp: bool,
};

export default LoadingWrapper;
